import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { registerSchema } from './validation';
import Layout from '../../layout/Layout';
import { TextForm, Password, GenericFields, ValidationBlock } from 'components/atoms';
import FormLayout from 'layout/FormLayout';
import { useActions } from 'hooks/useActions';
import { withGoogleReCaptcha } from 'hoc/withGoogleReCaptcha';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { GOOGLE_AUTH_LINK } from 'utils/constants';
import './styles.scss';

const Component = () => {
  const [validate, setValidate] = React.useState(false);
  const { registerUserWithEmail } = useActions();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    requestAnimationFrame(() => {
      inputRef?.current?.focus();
      inputRef?.current?.setSelectionRange(0, 0);
    });
  }, [inputRef]);

  const formFields = [
    {
      name: 'name',
      label: 'FULLNAME',
      Component: TextForm,
      inputRef: inputRef,
    },
    {
      name: 'username',
      label: 'USERNAME',
      Component: TextForm,
      inputProps:{
        autoComplete: 'new-username',
      }
    },
    {
      name: 'email',
      label: 'EMAIL',
      Component: TextForm,
      type: 'email'
    },
    {
      name: 'password',
      label: 'PASSWORD',
      Component: Password,
      type: 'password'
    },
  ];
  
  return (
    <Layout>
      <FormLayout>
        <Formik
          initialValues={{
            name: '',
            username: '',
            email: '',
            password: '',
          }}
          validationSchema={registerSchema}
          validateOnChange={validate}
          validateOnBlur={false}
          onSubmit={async (values) => {
            if (!executeRecaptcha) {
              return;
            }
            const token = await executeRecaptcha('register');
            registerUserWithEmail({ ...values, token }, navigate, executeRecaptcha);
          }}
        >
          {(props) => (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                setValidate(true);
                props.handleSubmit(e);
              }}
              noValidate
            >
              <div>
                <div className="field-list">
                  <h2 className="kcor-stel">Let's Rock</h2>
                </div>
                <ValidationBlock />
                <GenericFields fields={formFields} submitText="Sign Up" />
                <div className="field-list">
                  <p style={{ margin: 0, padding: '15px' }}>
                    By clicking Sign Up, you agree to our{' '}
                    <a href="/terms-of-service" target="_blank" style={{ color: 'black', cursor: 'pointer' }}>
                      Terms
                    </a>
                    . Learn how we collect, use and share your data in our{' '}
                    <a href="/privacy-policy" target="_blank" style={{ color: 'black', cursor: 'pointer' }}>
                      Privacy Policy
                    </a>
                    .
                  </p>
                </div>
                <div className="field-list separator">
                  <div className="data-name">
                    <p>
                      <a href={GOOGLE_AUTH_LINK}>Continue with Google</a>
                    </p>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </FormLayout>
    </Layout>
  );
};

export const Register = withGoogleReCaptcha(Component);
